import { isLogicFollowSA } from '..';

const SLCompass = Mach.requireModule('SLCompass');
const SLLocation = Mach.requireModule('SLLocation');
const SLUserAddress = Mach.requireModule('SLUserAddress');

export function checkAddress(region?: string) {
  if (!region) {
    return false;
  }
  const regionInfo = SLCompass?.getRegionInfo?.() || {};
  const isOpenSARegion = regionInfo.openSARegion?.homePage || false;
  if (!isOpenSARegion) {
    return false;
  }
  let { region: compassRegion } = SLCompass.getCompassInfo();
  compassRegion = compassRegion ? compassRegion.toLowerCase() : '';
  const addressRegion = region ? region.toLowerCase() : '';
  return compassRegion !== addressRegion;
}

export function checkRegionEqual(region?: string) {
  if (!region) {
    return false;
  }
  let { region: compassRegion } = SLCompass?.getCompassInfo() || {};
  compassRegion = compassRegion ? compassRegion.toLowerCase() : '';
  return region.toLowerCase() === compassRegion;
}

export function showLimitSuggestPoi() {
  const { region } = SLCompass?.getCompassInfo?.() || {};
  return isLogicFollowSA(region);
}

export function showLimitSourcePoi() {
  return checkRegionEqual('HK');
}

export function isSARegion() {
  return checkRegionEqual('SA');
}

export function updateDisplayName(selectedLocale) {
  const location = SLLocation?.getLocation();
  if (location?.isFromRegionPage) {
    SLUserAddress.updateCityDisplayName?.({ cityId: location?.detail?.cityId || '', lang: selectedLocale });
  }
}

// 判断两个对象是否相等，ignoredProperties：需要跳过的字段
export function isEqualIgnoringProperties<T>(obj1: T, obj2: T, ignoredProperties: string[]): boolean {
  if (obj1 === obj2) {
    return true;
  }

  if (!obj1 || !obj2) {
    return obj1 === obj2;
  }

  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  return keys1.every((key) => ignoredProperties.includes(key)
    || (keys2.includes(key) && isEqualIgnoringProperties(obj1[key], obj2[key], ignoredProperties)));
}
